export default __webpack_public_path__ + "static/media/open_active.61df3671.svg";